function ShopWithCardFooter({ children }: { children: React.ReactNode }) {
  return (
    <div className="mt-auto flex items-center justify-center px-2 pb-3 pt-0">
      {children}
    </div>
  )
}

export { ShopWithCardFooter }
